import {registerTemplate } from '@contentpepper-publisher/theme-ing_academy';

export const availableTemplates: any = [registerTemplate()];

export const activeTemplates = ['theme-ing_academy'];
